import { AIPPT_PLUGIN_RECORD } from '@/constants/catalog';

export const usePluginsMineStore = defineStore('PluginsMineStore', {
    state: () => ({
        // 免费安装的插件记录（"已安装插件"页数据源）
        installedPlugins: [],
        // 本机是否装了 AiPPT（由 c 端 client_check_apippt 检测，不落盘）
        aipptInstalled: false,
    }),

    getters: {},

    actions: {
        // 插件安装记录与订单数据源分离，结构按"插件"语义精简。
        async addPluginRecord(plugin) {
            console.log("plugin", plugin, this.installedPlugins);

            const already = this.installedPlugins.findIndex((record) => record.product === plugin.name);
            console.log("already", already);

            // 刚装完，本次会话内不必再问 c 端（页面来回切换时按钮要保持「已安装」）
            if (plugin.name === AIPPT_PLUGIN_RECORD.product) this.aipptInstalled = true;

            if (already == -1) {
                this.installedPlugins.unshift({
                    product: plugin.name,
                    ico: plugin.icon,
                    devices: 1,
                });
                console.log(this.installedPlugins);

                await this.SAVE_installedPlugins();
            }
        },
        // 检测本机 AiPPT 安装状态，并让这条固定记录与检测结果保持一致。
        // 用户卸载 workai 会丢掉 c 端存储，但 AiPPT 还装着；重进应用靠这里把记录补回来。
        // 反之 AiPPT 被卸载后，这里把残留记录清掉。
        async SYNC_AipptRecord() {
            const appStore = useAppStore();

            try {
                const result: any = await appStore.MyWin.WorkAiApi("client_check_apippt");
                this.aipptInstalled = result?.code == 200 && result?.success;
            } catch (err) {
                // 检测失败不动记录：沿用 c 端存储里已有的内容，避免误清
                console.error("[插件] AiPPT 安装检测失败", err);
                return this.aipptInstalled;
            }

            const index = this.installedPlugins.findIndex((record) => record.product === AIPPT_PLUGIN_RECORD.product);

            if (this.aipptInstalled && index == -1) this.installedPlugins.unshift({ ...AIPPT_PLUGIN_RECORD });
            else if (!this.aipptInstalled && index > -1) this.installedPlugins.splice(index, 1);
            // 记录没变化就不必重写 c 端存储
            else return this.aipptInstalled;

            await this.SAVE_installedPlugins();
            return this.aipptInstalled;
        },
        // AiPPT 装好了。两条安装路径共用：插件页单独安装、一键安装 office+aippt。
        // 记录内容是固定的死数据，这里只负责补记录 + 标记状态。
        async MARK_AipptInstalled() {
            this.aipptInstalled = true;

            const index = this.installedPlugins.findIndex((record) => record.product === AIPPT_PLUGIN_RECORD.product);
            if (index > -1) return;

            this.installedPlugins.unshift({ ...AIPPT_PLUGIN_RECORD });
            await this.SAVE_installedPlugins();
        },
        // 写入 c 端存储（与 UserInfo 同一份 blob，base64 编码）
        async SAVE_installedPlugins() {
            const appStore = useAppStore();

            await appStore.MyWin.WorkAiApi("client_save_data", appStore.strToBase64(JSON.stringify({
                UserInfo: appStore.UserInfo,
                installedPlugins: this.installedPlugins
            })));
        },
        SET_installedPlugins(data) {
            // c 端存储里可能没有这个字段（老 blob / 只存了 UserInfo），兜成空数组
            this.installedPlugins = Array.isArray(data) ? data : [];
        }
    }
});
